export default __webpack_public_path__ + "static/media/delete icon.fb84b46f.svg";